'use strict';
(function () {
  if (window.__VSKLO_CART_DEFERRED_RUNTIME_V2__) return;
  window.__VSKLO_CART_DEFERRED_RUNTIME_V2__ = true;

  var loader = window.VSKLOAssetLoader;
  if (!loader || typeof loader.loadScript !== 'function') {
    console.error('[VSKLO] shared asset loader is missing for cart deferred runtime');
    return;
  }

  var bootScript = document.currentScript;
  var cartDiscountSrc = bootScript?.dataset ? String(bootScript.dataset.discountSrc || '') : '';
  var cartNoteSrc = bootScript?.dataset ? String(bootScript.dataset.noteSrc || '') : '';
  var addonV3Src = bootScript?.dataset ? String(bootScript.dataset.addonV3Src || '') : '';

  window.VSKLOEnsureCartDiscountRuntime = function () {
    var existing = customElements.get('cart-discount');
    if (existing) return Promise.resolve(existing);
    if (!cartDiscountSrc) return Promise.resolve(null);

    return loader.loadScript({
      key: 'cart-discount-runtime',
      src: cartDiscountSrc,
      parent: 'head',
      ready: function () {
        return customElements.get('cart-discount') || null;
      },
      label: 'Cart discount runtime'
    });
  };

  window.VSKLOEnsureCartNoteRuntime = function () {
    var existing = customElements.get('cart-note');
    if (existing) return Promise.resolve(existing);
    if (!cartNoteSrc) return Promise.resolve(null);

    return loader.loadScript({
      key: 'cart-note-runtime',
      src: cartNoteSrc,
      parent: 'head',
      ready: function () {
        return customElements.get('cart-note') || null;
      },
      label: 'Cart note runtime'
    });
  };

  window.VSKLOEnsureCartAddonV3 = function () {
    if (window.VSKLOAddonV3 && typeof window.VSKLOAddonV3.init === 'function') {
      return Promise.resolve(window.VSKLOAddonV3);
    }
    if (!addonV3Src) return Promise.resolve(null);

    return loader.loadScript({
      key: 'cart-addon-v3-runtime',
      src: addonV3Src,
      parent: 'head',
      ready: function () {
        return window.VSKLOAddonV3 && typeof window.VSKLOAddonV3.init === 'function'
          ? window.VSKLOAddonV3
          : null;
      },
      label: 'Cart add-on V3 runtime'
    });
  };

  function root() {
    return document.getElementById('main-cart-items');
  }

  function warmForTarget(target) {
    if (!target || typeof target.closest !== 'function') return;

    if (cartNoteSrc && target.closest('cart-note')) {
      window.VSKLOEnsureCartNoteRuntime().catch(function (error) {
        if (window.VSKLO_DEBUG) {
          console.warn('[VSKLO] Deferred cart note runtime failed to load', error);
        }
      });
    }

    if (cartDiscountSrc && target.closest('cart-discount')) {
      window.VSKLOEnsureCartDiscountRuntime().catch(function (error) {
        if (window.VSKLO_DEBUG) {
          console.warn('[VSKLO] Deferred discount runtime failed to load', error);
        }
      });
    }

    if (
      addonV3Src &&
      target.closest('[data-vsklo-open-cart-addons], [data-vsklo-cart-addon-popup]')
    ) {
      window.VSKLOEnsureCartAddonV3().catch(function (error) {
        if (window.VSKLO_DEBUG) {
          console.warn('[VSKLO] Deferred cart add-on runtime failed to load', error);
        }
      });
    }
  }

  function replayAfterRuntimeLoad(element, eventType, replayMarker, ensureRuntime) {
    if (!element || element.dataset[replayMarker] === '1') return;

    ensureRuntime()
      .then(function () {
        if (!element.isConnected) return;

        element.dataset[replayMarker] = '1';
        try {
          if (eventType === 'submit' && typeof element.requestSubmit === 'function') {
            element.requestSubmit();
          } else {
            element.dispatchEvent(new Event(eventType, { bubbles: true }));
          }
        } finally {
          delete element.dataset[replayMarker];
        }
      })
      .catch(function (error) {
        console.error('[VSKLO] Deferred cart interaction failed', error);
      });
  }

  function bindWarmup() {
    var cartRoot = root();
    if (!cartRoot || cartRoot.dataset.vskloDeferredWarmup === '1') return;
    cartRoot.dataset.vskloDeferredWarmup = '1';

    cartRoot.addEventListener('pointerover', function (event) {
      warmForTarget(event.target);
    }, { passive: true });
    cartRoot.addEventListener('pointerdown', function (event) {
      warmForTarget(event.target);
    }, { passive: true });
    cartRoot.addEventListener('touchstart', function (event) {
      warmForTarget(event.target);
    }, { passive: true });
    cartRoot.addEventListener('focusin', function (event) {
      warmForTarget(event.target);
    });

    cartRoot.addEventListener('submit', function (event) {
      var form = event.target?.closest ? event.target.closest('cart-discount form') : null;
      if (
        !form ||
        form.dataset.vskloReplaySubmit === '1' ||
        customElements.get('cart-discount')
      ) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      replayAfterRuntimeLoad(
        form,
        'submit',
        'vskloReplaySubmit',
        window.VSKLOEnsureCartDiscountRuntime
      );
    }, true);

    cartRoot.addEventListener('change', function (event) {
      var field = event.target?.closest ? event.target.closest('cart-note textarea') : null;
      if (
        !field ||
        field.dataset.vskloReplayChange === '1' ||
        customElements.get('cart-note')
      ) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      replayAfterRuntimeLoad(
        field,
        'change',
        'vskloReplayChange',
        window.VSKLOEnsureCartNoteRuntime
      );
    }, true);
  }

  bindWarmup();
  document.addEventListener('vsklo:content-updated', bindWarmup);
})();